import gql from 'graphql-tag';

export const ROOM_FIELDS = gql`
	fragment PlansRoomFields on Room {
		_id
		createdDate
		createdById
		lastModifiedDate
		lastModifiedById
		orgId
		serverId
		sortOrder
		projectId
		type
		customType
		typeCategory
		number
		description
		clarification
		isDefault
		isOther
		level
		levelId
		unit
	}
`;
